import axios, {
  AxiosResponse,
  AxiosInstance,
  AxiosRequestConfig as DefaultAxiosRequestConfig,
} from 'axios';

export type RequestType = {
  payload?: any;
  params?: any;
  headers?: any;
};

export type ResponseType = {
  response?: any;
};

export interface AxiosRequestConfig<T extends RequestType> extends DefaultAxiosRequestConfig {
  data?: T['payload'];
  params?: T['params'];
  headers?: T['headers'];
}

export enum Method {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

let axiosInstance: AxiosInstance;

export function initBrowserAxios() {
  if (axiosInstance) {
    return;
  }

  axiosInstance = axios.create({
    // 120 sec timeout
    timeout: 120000,
    // cap the maximum content length we'll accept to 600MBs, just in case
    maxContentLength: 30 * 20 * 1000 * 1000,
    // follow up to 10 HTTP 3xx redirects
    maxRedirects: 10,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  });
}

export const callAxios = async <T extends (RequestType & ResponseType)>(
  config: AxiosRequestConfig<T['headers'] & T['params'] & T['payload']>,
): Promise<AxiosResponse<T['response']>> => {
  try {
    const response = await axiosInstance.request(config);

    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
